<template>
  <div class="px-4 pb-4">
    <data-table :columns="columns" :rows="rows">
      <template v-slot:actions="slotProps">
        <div class="button-items">
          <b-button v-if="checkForPermission(view_single_user_role_permission)" variant="info" size="sm" class="py-1 text-white" @click="singleRole(slotProps.row.id)">
            View User Role
          </b-button>
          <b-button v-if="checkForPermission(edit_user_role_permission)" v-b-modal.edit-role variant="success" size="sm" class="py-1 text-white" @click="selectRole(slotProps.row)">
            Edit User Role
          </b-button>
        </div>
      </template>
    </data-table>
    <b-modal
        id="edit-role"
        centered
        hide-footer
        hide-header
        title-class="font-18">
      <div class="p-2">
        <h3>Edit User Role</h3>
        <new-user-role-form button_text="Edit User Role" :selected_role="selected_role" @roleAction="editRole"/>
        <b-button class="mt-3 float-end" variant="dark" block @click="$bvModal.hide('edit-role')">Close</b-button>
      </div>
    </b-modal>
  </div>
</template>

<script>
import {routeItems} from "@/router/endpoints";
import NewUserRoleForm from "@/components/roles/new-user-role-form";
import DataTable from "@/components/data-table";
import {mapActions} from "vuex";
import Swal from "sweetalert2";
import {permissions} from "@/router/permissions";

export default {
name: "user-roles-table",
  components: {DataTable, NewUserRoleForm},
  data(){
    return{
      searchTerm: '',
      selected_role: {},
      edit_user_role_permission: permissions.edit_user_role_permission,
      view_single_user_role_permission: permissions.view_single_user_role_permission,
      columns: [
        {
          field: 'name',
          label: 'Name'
        },
        {
          field: 'permissions',
          label: 'Permissions'
        },
        {
          field: 'actions',
          label: 'Action'
        }
      ],
    }
  },
  props: {
    rows: {type: Array}
  },
  methods: {
    ... mapActions({
      updateRole: 'user/updateUserRole'
    }),
    singleRole(id){
      this.$router.push(routeItems.single_user_role_route+'/'+id)
    },
    async editRole(data){
      data.id = parseInt(this.selected_role.id)
      await this.updateRole(data).then(resp => {
        if(resp.name){
          this.$emit('refetch')
          Swal.fire({
            toast: true,
            position: 'top-end',
            icon: 'success',
            text: `${resp.name} updated successfully`,
            showConfirmButton: false,
            timer: 1500
          })
        }
      })
    },
    selectRole(row){
      const widgetNames = []
      row.widgets.forEach((widget) => {
        widgetNames.push(widget.widget)
      })
      this.selected_role = {
        ...row,
        widgets: widgetNames
      }
    }
  }
}
</script>

<style scoped>

</style>
